import { itemServices } from 'src/services/reservation/item/item.service'
import { customAwait } from 'src/components/pages/sales/reservation/helper/customAwait'
import { GUARANTEED } from '../logic/common/state'
type Refresh = () => void

interface afterSalesItemReservationParams {
  hashItemReserve: string
  nameReserve: string
  refresh: Refresh
  notify: any
  setLoadingAfterSalesItem: React.Dispatch<React.SetStateAction<boolean>>
  setNameReserve: React.Dispatch<React.SetStateAction<string>>
  setHashItemReserve: React.Dispatch<React.SetStateAction<string>>
  setConfirmAfterSales: React.Dispatch<React.SetStateAction<boolean>> | undefined
  setOpenAfterSalesModal: React.Dispatch<React.SetStateAction<boolean>> | undefined
}

export const afterSalesItemReservation = async ({
  hashItemReserve,
  nameReserve,
  refresh,
  notify,
  setLoadingAfterSalesItem,
  setNameReserve,
  setHashItemReserve,
  setConfirmAfterSales,
  setOpenAfterSalesModal,
}: afterSalesItemReservationParams): Promise<void> => {
  try {
    setLoadingAfterSalesItem(true)
    setOpenAfterSalesModal && setOpenAfterSalesModal(false)
    let status = null
    status = await itemServices.clone_item_online(hashItemReserve)

    
    if (status == 200) {
      notify('ra.notification.aftersales_item_success', {
        type: 'success',
        messageArgs: { item: nameReserve },
      })
      setNameReserve('')
      setHashItemReserve('')
      setConfirmAfterSales && setConfirmAfterSales(false)
      setLoadingAfterSalesItem(false)
      return
    }
    setNameReserve('')
    setHashItemReserve('')
    setConfirmAfterSales && setConfirmAfterSales(false)
    setLoadingAfterSalesItem(false)
    notify('ra.notification.aftersales_item_error', {
      type: 'error',
      messageArgs: { item: nameReserve },
    })
  } catch (error) {
    notify('ra.notification.aftersales_item_error', {
      type: 'error',
      messageArgs: { item: nameReserve },
    })
    setNameReserve('')
    setHashItemReserve('')
    setLoadingAfterSalesItem(false)
    setConfirmAfterSales && setConfirmAfterSales(false)
    setOpenAfterSalesModal && setOpenAfterSalesModal(false)
  } finally {
    customAwait([refresh])
  }
}